import docCookies from 'doc-cookies';
import { BASE_URL_SANCTUM, BASE_ORDER_URL } from '../misc/consts';

export default () => {
  return {
    async getXsfrToken() {
      const response = await fetch(BASE_URL_SANCTUM);
      if (!response.ok) {
        this.somethingWentWrong = true;
        throw new Error(`Error! status: ${response.status}`);
      }
    },

    async sentPaymentInstructions(id) {
      await this.getXsfrToken();

      fetch(`${BASE_ORDER_URL}/${id}/send-payment-instructions`, {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-XSRF-TOKEN': docCookies.getItem('XSRF-TOKEN'),
        },
        method: 'PUT',
      })
        .then(async (response) => {
          if (!response.ok) {
            throw new Error('Network response was not OK');
          }
          return response.json();
        })
        .then((response) => {
          if (response.success) {
            this.disablePaymentInstructionButton(id);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async deleteOrder(id) {
      await this.getXsfrToken();
      fetch(`${BASE_ORDER_URL}/${id}`, {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-XSRF-TOKEN': docCookies.getItem('XSRF-TOKEN'),
        },
        method: 'DELETE',
      }).then((response) => {
        if (response.ok) {
          this.$el.parentElement.parentElement.parentElement.parentElement.remove();
        }
      });
    },

    disablePaymentInstructionButton(id) {
      let button = document.getElementById(`sent-payment-instructions-${id}`);
      button.disabled = true;
      button.classList.add('btn-disabled');
      button.textContent = 'Platební instrukce odeslány';
    },
  };
};
